import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'

let configBase = document!.querySelector('meta[name="febis-questionizer-config-url"]')?.getAttribute('content');
if (configBase !== undefined) {
    ReactDOM.createRoot(document.getElementById('febis-questionizer')!).render(
    <React.StrictMode>
      <App configBase={configBase}/>
    </React.StrictMode>);
  }else{
    console.warn("Keine Konfiguration gefunden");
  }